import { Component } from '@angular/core';

@Component({
    selector: 'app-nutrizionista',
    imports: [],
    templateUrl: './nutrizionista.component.html',
    styleUrl: './nutrizionista.component.css'
})
export class NutrizionistaComponent {

}
